import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Follow up to The most pleasant job interview I have ever had",
  "description": "",
  "published": "2013-05-23T00:00:00.000Z",
  "redirect_from": ["/blog/follow-up-to-the-most-pleasant-job-interview-i-have-ever-had/swizec/6190"],
  "categories": "Canada, Employment, Interview, Ramit Sethi, Shopify, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/9HlBZ5SbQGeZE0urzi2s",
        "alt": null
      }}></img></p>
    <p><em parentName="p">{`"Hey mum, I'm going to Canada in September to work for `}<a parentName="em" {...{
          "href": "http://shopify.com",
          "title": "Shopify"
        }}>{`Shopify`}</a>{`."`}</em></p>
    <p><em parentName="p">{`"Yeah I know, why did you take a month to realize that?"`}</em></p>
    <p>{`Just over a month ago I described my experience interviewing with Shopify as `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/the-most-pleasant-job-interview-i-have-ever-had/swizec/6121"
      }}>{`the most pleasant job interview I have ever had`}</a>{`.`}</p>
    <p>{`Just three days after the interview I got an offer, but fussed over the decision for a month. Originally, to give some other opportunities a fair chance, later because some new opportunities showed up ...`}</p>
    <p>{`Seriously, what are the chances for a client to sell his company to a huge investment bank and wanting to bring you on board juuust as you're thinking about moving to Canada? Crazy. I didn't take that one because, you know, `}<em parentName="p">{`bank`}</em>{`. Huge corporation. Not really my style ... at least not for that kind of money.`}</p>
    <p>{`Remember kids, if you're going to sell your soul, sell it well.`}</p>
    <p>{`I loved Shopify when I was there, it was the most fun and enjoyable looking environment I have ever seen. If I had to decide there and then, I'd go for it at the drop of a hat. But the more I thought about it, the more my fear of commitment acted up.`}</p>
    <p>{`The main reason I freelance is the pace of switching whole technology stacks every few months. But I also have `}<em parentName="p">{`a lot`}</em>{` of free time to pursue my own stuff. Deadlines for a book you say? No problem, ten billable days in a month is enough.`}</p>
    <p>{`Think I won't be able to do that anymore.`}</p>
    <p>{`Oh, you like waking up at 9am, taking an hour to exercise and then two hours for writing and an hour for lunch and `}<em parentName="p">{`then`}</em>{` get to work work? No problem, you're more productive coding-wise in the afternoon/evening anyway.`}</p>
    <p>{`I have a suspicion I won't be able to do that anymore either.`}</p>
    <p>{`In the end, that's why I decided to work at Shopify. Because it scares me shitless. That which scares you the most is usually the best way forward. It's your inner comfy coward screaming from the top of his wee lungs that way lies change.`}</p>
    <p>{`Change is good. I like change.`}</p>
    <p>{`At least I'll still have the freedom to work on my own stuff - yes, I asked - and following `}<a parentName="p" {...{
        "href": "http://www.ramitsethi.com/",
        "title": "Ramit Sethi"
      }}>{`Ramit Sethi`}</a>{`'s advice to ask for a few extra $k/year, I'm going to have plenty of financial independence as well. Important things those two.`}</p>
    <p>{`I can't weave this smoothly into the story so I'm just going to say it. Subscribe to Ramit's mailing list. Do it. Read it. It will change the way you think in ever so subtle ways. I mean, when was the last time casually reading a free mailing list made you a few thousand dollars? Exactly.`}</p>
    <p>{`But yeah, in September I start working for Shopify and that will be the end of my relatively short-lived full-time freelancing career. For now.`}</p>
    <p>{`Now how the hell do I write a resume that will impress a government clerk deciding whether I'm good enough for a visa?`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=ccd882ae-571f-43ec-9b15-e95340b0edcf",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      